import { render, staticRenderFns } from "./BaseLoadingSpinner.vue?vue&type=template&id=4b3ab064&scoped=true"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingSpinner.vue?vue&type=style&index=0&id=4b3ab064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ab064",
  null
  
)

/* custom blocks */
import block0 from "./BaseLoadingSpinner.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports